module.exports = __webpack_public_path__ + "static/media/field-yellow.aa16d1eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/field-yellow.svg
// module id = 53
// module chunks = 0